import React, { useContext, useEffect, useState } from 'react';
import {
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Menu,
  MenuButton,
  Radio,
  RadioGroup,
  useDisclosure,
  VStack,
  chakra,
  Button,
  Input,
  HStack,
  InputGroup,
  InputRightElement,
  InputLeftElement,
  Spacer,
  Text,
  Box,
  Image,
} from '@chakra-ui/react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/form-control';
import { useField } from 'formik';
import { ChevronDownIcon, Search2Icon } from '@chakra-ui/icons';
import { AccountContext } from './AccountContext';
import ModalAvisoEspecialidade from './ModalAvisoEspecialidade';
import Sino from '../images/sino.svg';

const SelectEspecialistas = ({ label, ...props }) => {
  const { options, placeholder, onChange, agendaAberta, idade, notificacao } = props;
  const [field, meta, helpers] = useField(props);
  const { value } = meta;
  const [textSearch, setTextSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const { setValue } = helpers;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const modalAvisoAgendamento = useDisclosure();
  const btnRef = React.useRef();
  const colorErro = meta.error ? { colorScheme: 'red' } : {};
  const [searchResults, setSearchResults] = useState(options);

  let textButton;

  if (typeof value === 'number' && value >= 0) {
    const option = options[value];

    if (typeof option?.descricao === 'string') {
      textButton = option.descricao.substring(0, 25) + (option.descricao.length > 25 ? '...' : '');
    } else {
      textButton = '';
    }
  } else if (placeholder) {
    textButton = placeholder;
  } else {
    textButton = 'Selecionar';
  }

  const search = async () => {
    setLoading(true);
    const filteredArr = options.filter((word) =>
      word.descricao
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .includes(
          textSearch
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
        )
    );

    setSearchResults(filteredArr);
    setLoading(false);
  };

  const [opcaoSelecionada, setOpcaoSelecionada] = useState([]);

  useEffect(() => {
    setOpcaoSelecionada(opcaoSelecionada);
  }, [opcaoSelecionada]);

  function validaLimitacao(idade, especialidade) {
    switch (especialidade) {
      case 54: //psicologia
        return idade >= 12;
      case 235: //neuro pediatra
        return idade >= 3;
      case 72: //neuro
        return idade >= 12;
      case 169: //geriatra
        return idade >= 60;
      default:
        return true;
    }
  }
  useEffect(() => {
    setSearchResults(options);
  }, [options]);
  return (
    <>
      <FormControl isInvalid={meta.error}>
        <FormLabel>{label}</FormLabel>
        <Menu>
          <Center>
            <MenuButton color={'#9E9E9E'} as={Button} onClick={onOpen} rightIcon={<ChevronDownIcon />} {...field} {...props} {...colorErro}>
              {textButton}
            </MenuButton>
          </Center>
        </Menu>
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      </FormControl>
      <ModalAvisoEspecialidade disclosure={modalAvisoAgendamento} dados={opcaoSelecionada} />
      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent borderRadius={20} width="90" h="80%">
          <DrawerBody>
            <HStack mt={'1em'}>
              <InputGroup>
                <InputLeftElement width="15%">
                  <Button
                    background={'none'}
                    width="100%"
                    children={<Search2Icon color="orange" />}
                    onClick={search}
                    isLoading={loading}
                    mt={'0.5em'}
                  ></Button>{' '}
                </InputLeftElement>
                <Input
                  placeholder="Buscar especialidade"
                  focusBorderColor="teal"
                  backgroundColor="#EEEEEE"
                  h={'3em'}
                  shadow="lg"
                  borderRadius={'0.8em'}
                  value={textSearch}
                  onChange={(event) => setTextSearch(event.target.value)}
                  onKeyUp={(event) => {
                    search();
                  }}
                />
              </InputGroup>
            </HStack>

            <RadioGroup
              name="select"
              w="100%"
              value={value}
              pb={5}
              onChange={(e) => {
                const selectedOption = searchResults[e];
                const selectedIndex = options
                  ? options.findIndex((option) => option.ambulatorio_tipo_consulta_id === selectedOption.ambulatorio_tipo_consulta_id)
                  : null;

                if (selectedIndex !== -1) {
                  setValue(selectedIndex);
                  onChange(e);
                  onClose();
                }
              }}
            >
              <VStack align="start" w="100" spacing={1} mt={'1em'}>
                {searchResults.map((option, index) => {
                  const dataFormatada = option?.proxima_data
                    ? new Date(option.proxima_data).toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                      })
                    : null;
                  const isValid = !validaLimitacao(idade, option.ambulatorio_tipo_consulta_id);
                  return (
                    <HStack spacing={4} align="center" direction={['column', 'row']} width="100%" key={index}>
                      <Box flex="1" minWidth="0">
                        <Radio value={index} padding="1em" autofocus="true" isDisabled={isValid}>
                          <chakra.p
                            fontWeight="bold"
                            fontSize="14px"
                            color="#616161"
                            wordBreak="break-all"
                            whiteSpace="nowrap"
                            overflow="hidden"
                            textOverflow="ellipsis"
                            width="150px"
                          >
                            {option?.descricao && option?.descricao?.length > 18 ? `${option.descricao.slice(0, 10)}...` : option.descricao}
                          </chakra.p>

                          {option.data_disponivel ? (
                            <chakra.p fontSize="14px" color={'white'} bg={'#9E9E9E'} p={1} borderRadius={'0.5em'} textAlign={'center'}>
                              Próxima data: {dataFormatada}
                            </chakra.p>
                          ) : (
                            <chakra.p fontSize="14px" color={'white'} bg={'#E96F6B'} p={1} borderRadius={'0.5em'} textAlign={'center'}>
                              Agenda cheia
                            </chakra.p>
                          )}
                        </Radio>
                      </Box>
                      <HStack
                        bg={option.data_disponivel && option?.agendas_disponiveis > 0 ? '#18A403' : 'none'}
                        border={option.data_disponivel && option?.agendas_disponiveis > 0 ? 'none' : '1px solid grey'}
                        borderRadius={'0.5em'}
                        p={1}
                        direction="column"
                        spacing={1}
                        alignItems="center"
                        width={option.data_disponivel && option?.agendas_disponiveis > 0 ? '125px' : '120px'}
                        height="100%"
                        justifyContent="center"
                        onClick={() => {
                          if (notificacao.includes(option.ambulatorio_tipo_consulta_id)) return;
                          if (!option.data_disponivel || option?.agendas_disponiveis <= 0) {
                            notificacao.push(option.ambulatorio_tipo_consulta_id);
                            modalAvisoAgendamento.onOpen();
                            setOpcaoSelecionada({
                              especialidade_id: option.ambulatorio_tipo_consulta_id,
                              paciente_id: props.cliente_id,
                              username: props.cpf,
                            });
                          }
                        }}
                      >
                        {option.data_disponivel && option?.agendas_disponiveis > 0 ? (
                          <>
                            <Text color={'#FFFFFF'} fontSize={'20px'}>
                              {option?.agendas_disponiveis}
                            </Text>
                            <Text color={'#FFFFFF'} fontSize={'14px'}>
                              vagas <br />
                              <p style={{ marginTop: '-0.5em' }}>disponíveis!</p>
                            </Text>
                          </>
                        ) : (
                          <>
                            {!notificacao.includes(option.ambulatorio_tipo_consulta_id) && (
                              <Text color={'#EEEEEE'} fontSize={'20px'}>
                                <Image src={Sino} />
                              </Text>
                            )}

                            <Text color={'grey'} fontWeight={'bold'} fontSize={'14px'}>
                              {notificacao.includes(option.ambulatorio_tipo_consulta_id) ? 'Já na fila' : 'Me avise!'}
                            </Text>
                          </>
                        )}
                      </HStack>
                    </HStack>
                  );
                })}
              </VStack>
            </RadioGroup>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default SelectEspecialistas;
